import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useSessionTimeout } from '@modules/app/composables/useSessionTimeout';

const RADIUS = 52;

export default /*@__PURE__*/_defineComponent({
  __name: 'SessionTimeoutModal',
  setup(__props, { expose: __expose }) {
  __expose();

const { state, countdown, stayLoggedIn, goToLogin } = useSessionTimeout();

const circumference = 2 * Math.PI * RADIUS;
const dashOffset = computed(() => {
  const fraction = countdown.value / 60;
  return circumference * (1 - fraction);
});

function onBackdropClick() {
  // Only explicit button click dismisses the warning
}

const __returned__ = { state, countdown, stayLoggedIn, goToLogin, RADIUS, circumference, dashOffset, onBackdropClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})